import { Theme, css } from '@emotion/react';

export const yourListsTitle = ({ spacing }: Theme) => css`
  margin-bottom: ${spacing(3)}px;
  align-items: center;
`;
